import { render, staticRenderFns } from "./EcoTransesofageaEdit.vue?vue&type=template&id=741e6777&scoped=true"
import script from "./EcoTransesofageaEdit.vue?vue&type=script&lang=js"
export * from "./EcoTransesofageaEdit.vue?vue&type=script&lang=js"
import style0 from "./EcoTransesofageaEdit.vue?vue&type=style&index=0&id=741e6777&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741e6777",
  null
  
)

export default component.exports